import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import config from "../config";
import { OpenSmsRunOutAlerts } from "store/slices/calendarSlice";

const SmsRunOutAlerts = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const rightDrawerOpened = useSelector((state) => state.calendar.isSmsRunOutAlerts);
    const smsAlertData = useSelector((state) => state.salon.isSmsAlertData);
    const remainingTotal = smsAlertData && typeof smsAlertData.remaining_sms !== "undefined" ? Number(smsAlertData.remaining_sms) : 0;
    const headline = remainingTotal > 0
        ? t("You have {{count}} monthly SMS credits remaining. Add more credits now to keep your clients in the loop.", { count: remainingTotal })
        : t("You have run out of monthly SMS credits. Add more credits now to keep your clients in the loop.");

    const closeAlert = () => dispatch(OpenSmsRunOutAlerts(""));

    return (
        <div className={rightDrawerOpened == "open" ? "modal fade show aca-modal-contents" : "modal fade"} id="modal-video-academys" tabIndex="-1" aria-labelledby="addcategoryModalLabel" aria-hidden="true" style={{ display: rightDrawerOpened == "open" ? "block" : "none" }}>
            <div className="modal-upgrade-premium-header">
                <div className="modal-upgrade-container sms-run-out-alert-container">
                    <div className="container modal-upgrade-ac-wrapper sms-out-alert-wrapper">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-md-6 modal-header-container d-flex flex-column p-0 align-items-center align-items-md-start">
                                        <h5>{headline}</h5>
                                        <p>{t("You will need to add more SMS credits to your account for your SMS client notifications and automated SMS marketing campaigns to continue working.")}</p>
                                        <div className="col-8 justify-self-end">
                                            <Link role="button" to={config.basePath + "/settings?tab=SMSUsage"} className="btn btn-primary add-new-btn px-3 fw-bold cursor-pointer w-100" onClick={closeAlert}>
                                                {t("Upgrade Now")}
                                            </Link>
                                        </div>
                                        <div className="col-8 text-center">
                                            <a className="text-decoration-underline text-dark w-100 mt-2 cursor-pointer">
                                                <span onClick={closeAlert}>{t("Close")}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex aligns-items-center justify-content-center img-everyday-market-modal">
                                        <img src={config.imagepath + "sms-run-out-alerts.png"} alt="automated.png" className="upgrade-modal-image-wh-set mt-2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {rightDrawerOpened == "open" && <div className=" modal-background-color show"></div>}
        </div>
    );
};

export default SmsRunOutAlerts;
